<template>
  <div class="wrapper-overlay open-overlay ">
    <div class="header-overlay header-overlay-svg">
      <img src="/ext_files/prepaid/f2g/images/logotype_dark.svg">
      <svg v-on:click="closeSavedCardComponent()" class="close-overlay" width="30px" height="30px" viewBox="0 0 30 30"
        version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <desc>Created with Sketch.</desc>
        <g id="Icon/Menu/close" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path
            d="M4.38605846,25.6177075 C4.64303181,25.8725692 4.97774286,26 5.31247602,26 C5.6471926,26 5.98188707,25.8725692 6.23889359,25.6177075 L15,16.8528625 L23.7633218,25.6177075 C24.0202952,25.8725692 24.3528502,26 24.6897394,26 C25.024456,26 25.3591505,25.8725692 25.616157,25.6177075 C26.1279477,25.1058277 26.1279477,24.2764407 25.616157,23.7645498 L16.8528372,15.0019165 L25.6139457,6.23707158 C26.1257364,5.72519181 26.1257364,4.89580481 25.6139457,4.38391398 C25.102155,3.87202315 24.2729123,3.8720342 23.7611106,4.38391398 L15,13.1487589 L6.2366823,4.38612565 C5.7248916,3.87424587 4.89564893,3.87424587 4.38384717,4.38612565 C3.87204541,4.89800542 3.87205647,5.72739242 4.38384717,6.23928325 L13.1471669,15.0019165 L4.38605846,23.7667615 C3.87426776,24.2786413 3.87426776,25.1058719 4.38605846,25.6177627 L4.38605846,25.6177075 Z"
            id="Path" fill="#FFFFFF" fill-rule="nonzero"></path>
        </g>
      </svg>
    </div>
    <div class="container-overlay overlay-form">

      <div class="title-overlay1">
        {{ content["myf2g.topupsavedcard.title"] }}
      </div>
      <div class="title-overlay4">
        {{ content["myf2g.topupsavedcard.subtitle"] }}
      </div>
      <div class="container-max-width-370">
        <div class="box-payment-topup">
          <img :src="setCardIcon(cardBrand)">
          <div class="descr-payment">
            {{ cardPan }}
            <div class="smaller-text-descr">{{ content["myf2g.topupsavedcard.message"] }} {{ cardExpiryDate }}</div>
          </div>
          <a v-on:click="showDeleteCardMessage = !showDeleteCardMessage" class="delete-payment">
            <img src="/ext_files/prepaid/f2g/images/delete.svg" />
          </a>
        </div>
        <div v-if="showDeleteCardMessage" class="title-overlay3-left">
          {{ content["myf2g.topupsavedcard.paragraph"] }} <span v-if="showDeleteCardMessage" v-on:click="deleteCard()"
            class="font-red">{{ content["myf2g.topupsavedcard.button1"] }}</span>.
        </div>
        <div class="overlay-button-container ">
          <div class="container-button  blue-btn button-overlay button-bigger-font"
            v-on:click="initiatePaymentNativeWithSavedCard()">
            <div class="cursor-hand">{{ content["myf2g.topupsavedcard.button2"] }}</div>
          </div>
        </div>
        <div class="paragr-text cursor-hand" v-on:click="closeSavedCardComponent()">
          <a>{{ content["myf2g.topupsavedcard.button3"] }}</a>
        </div>
      </div>
    </div>
  </div>

</template>



<script>
import $ from 'jquery';
import axios from 'axios'
export default {
  name: "SavedCard",
  components: {

  },
  data: function () {
    return {
      showDeleteCardMessage: false,
      content: ''
    }
  },
  created() {
    let self = this;

    /************************
     *** WCS service call ***
     ************************/

    let url = ''

    if (this.locale === 'en_US') {
      url = '/en/myf2g-topup-saved-card-mock/'
    } else {
      url = '/gr/myf2g-topup-saved-card-mock/'
    }

    let configWCS = {
      sessionKey: "wcs_topup_saved_card",
      axiosConfig: {
        method: "get",
        url: '/gr/f2g/vueContentService/',
        params: {
          ciKey: 'myf2gtopupsavedcard',
          locale: self.locale
        }
      }
    }

    this.fetchDataFromWCS(configWCS)
      .then(response => {
        console.log(JSON.stringify(response))
        self.content = response
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        console.log("finally");
      });
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
    getIsDataJumpFlow() {
      return this.$store.state.isDataJumpFlow;
    },
    getUserProfileAndTariffsObject() {
      return this.$store.state.userProfileAndTariffsObject
    },
    cardAndRecurringInfoObject() {
      return this.$store.state.cardAndRecurringInfoObject;
    },
    cardBrand() {
      return this.$store.state.cardAndRecurringInfoObject.cardList[0].brand;
    },
    cardPan() {
      return this.$store.state.cardAndRecurringInfoObject.cardList[0].pan;
    },
    cardExpiryDate() {
      return this.$store.state.cardAndRecurringInfoObject.cardList[0].expiryDate;
    },
    token() {
      return this.$store.state.token;
    },
    getLocale() {
      var locale;
      if ($('body').data('locale') == "el_GR") {
        locale = "el";
      } else {
        locale = "en";
      }
      return locale;
    },
    email() {
      return this.$store.state.email;
    },
    amount() {
      return this.$store.state.amount;
    }
  },
  methods: {
    setCardIcon(cardBrand) {
      var iconCardSource;
      if (this.cardAndRecurringInfoObject.cardList.length > 0) {
        if (cardBrand.toLowerCase().includes("mastercard")) {
          iconCardSource = "/ext_files/prepaid/f2g/images/iconMastercard.png"
        } else if (cardBrand.toLowerCase().includes("visa")) {
          iconCardSource = "/ext_files/prepaid/f2g/images/iconVisa.png";
        } else if (cardBrand.toLowerCase().includes("maestro")) {
          iconCardSource = "/ext_files/prepaid/f2g/images/iconMestro.png";
        } else if (cardBrand.toLowerCase().includes("dinersclub")) {
          iconCardSource = "/ext_files/prepaid/f2g/images/iconDinersclub.png";
        } else if (cardBrand.toLowerCase().includes("americanexpress")) {
          iconCardSource = "/ext_files/prepaid/f2g/images/iconAmex.png";
        }
        return iconCardSource;
      }
    },
    closeSavedCardComponent() {
      this.$store.commit("showSavedCardComponent", false);
    },
    initiatePaymentNativeWithSavedCard: function () {
      this.$store.commit('showLoader');

      axios({
        method: "post",
        url: "/epayments/initiatePaymentNative",

        data: {
          "applicationName": this.$store.state.applicationName,
          "merchantRef": this.cardAndRecurringInfoObject.merchantRef,
          "secToken": this.cardAndRecurringInfoObject.secToken,
          "transactionCode": this.cardAndRecurringInfoObject.transactionCode,
          "amount": this.amount,
          "customerCode": this.$store.state.customerCode,
          "customerName": this.$store.state.customerName,
          "invoiceNumber": null,
          "callbackURI": null,
          "hostName": this.$store.state.hostName,
          "locale": this.getLocale,
          "msisdn": this.getUserProfileAndTariffsObject.msisdn,
          "msisdnActivationDate": this.getUserProfileAndTariffsObject.activationDate,
          "postalCode": null,
          "sendCallback": "false",
          "taxNumber": this.$store.state.taxNumber,
          "transferMsisdn": this.getUserProfileAndTariffsObject.msisdn,
          "twoStagesFlow": "false",
          "currency": "EUR",
          "userName": this.$store.state.guid,
          "saveCard": "false",
          "savedCard": this.cardAndRecurringInfoObject.cardList[0].datacacheReference,
          "useSavedCard": "true",
          "minNumberOfInstalments": 0,
          "maxNumberOfInstalments": 0,
          "numberOfInstalments": 0,
          "recurringType": "",
          "recurringDate": "",
          "recurringThreshold": "",
          "recurringService": "",
          "recurringAsset": "",
          "requestInvoice": true,
          "paymentMethod": "card",
          "email": this.email,
          "browser": this.determineBrowser(),
          "screenWidth": window.screen.width,
          "screenHeight": window.screen.height

        }

      }).then(response => {
        console.log("initiatePaymentNative " + JSON.stringify(response.data))
        if (response.data.result == "OK") {

          //clear service response from session storage
          sessionStorage.removeItem('getUserProfileAndTariffs_' + "F2G_" + this.token);
          sessionStorage.removeItem('getCardAndRecurringInfo_' + "F2G_" + this.token);

          //Add a key to session storage to know if we have returned from bank
          sessionStorage.setItem('activeFlow_F2G_' + this.token, false);

          //If it is a dataJumpflow create a cookie that will be used to check if we have used a datajump session
          if (this.getIsDataJumpFlow) {
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (3 * 24 * 60 * 60 * 1000)); // 3 days from now
            document.cookie = "dataJumpSession=true; expires=" + expiryDate.toUTCString() + "; path=/;";
          }

          /* redirect to bank*/
          console.log("initiate payment done")
          // window.location.href = document.getElementsByTagName("body")[0].dataset.windsite + "/epayments/beginPayment/?merchantRef=" + this.cardAndRecurringInfoObject.merchantRef +"&secToken=" +this.cardAndRecurringInfoObject.secToken;
          window.location.href = "/epayments/beginPayment/?merchantRef=" + this.cardAndRecurringInfoObject.merchantRef + "&secToken=" + this.cardAndRecurringInfoObject.secToken;

        } else {
          if (response.data.fault.faultCode == 19) {
            var faultDescription = response.data.fault.faultDescription;
            this.$store.commit('hideLoader');
            console.log(faultDescription);
            this.$store.commit("showSavedCardComponent", false);
            this.$store.commit('showErrorComponent', true);
            this.$store.commit("setFaultDescription", faultDescription);
          } else {
            console.log("initiatePaymentNative responded: " + response.data.result);
            this.$store.commit('hideLoader');
            this.$store.commit("showSavedCardComponent", false);
            this.$store.commit('showErrorComponent', true);
            console.log("initiate payment not done")
          }
        }
      }).catch(error => {
        this.$store.commit('hideLoader');
        this.$store.commit("showSavedCardComponent", false);
        this.$store.commit('showErrorComponent', true);
        console.log("initiatePaymentNative responded with error: " + error);
      });
    },
    deleteCard() {
      this.$store.commit('showLoader');
      var self = this;
      axios({
        method: "post", //service call for card deletion
        url: "/epayments/deleteCard",
        data:
        {
          "guid": this.$store.state.guid,
          "datacashReference": this.cardAndRecurringInfoObject.cardList[0].datacacheReference,
          "msisdn": this.getUserProfileAndTariffsObject.msisdn,
          "msisdnActivationDate": this.getUserProfileAndTariffsObject.activationDate
        }
      })
        .then(response => {
          console.log("getdeleteCard response: " + JSON.stringify(response.data));
          if (response.data.result == "OK") {
            var cardAndRecurringInfoObject = { "result": "OK", "merchantRef": this.cardAndRecurringInfoObject.merchantRef, "secToken": this.cardAndRecurringInfoObject.secToken, "transactionCode": this.cardAndRecurringInfoObject.transactionCode, "cardList": [], "isSuccess": true };
            this.$store.commit("setCardAndRecurringInfo", cardAndRecurringInfoObject);
            sessionStorage.setItem('getCardAndRecurringInfo_' + "F2G_" + self.token, JSON.stringify(cardAndRecurringInfoObject));
            this.$store.commit("showSavedCardComponent", false);
          }
          else {
            this.$store.commit('showErrorComponent', true);
          }
        })
        .catch(error => {
          console.log("getdeleteCard responded with error: " + error);
          this.$store.commit("showSavedCardComponent", false);
          this.$store.commit('showErrorComponent', true);
        })
        .finally(() => {
          this.$store.commit('hideLoader');
        });
    },
    determineBrowser() {
      var nAgt = navigator.userAgent ? navigator.userAgent : "";
      var browserName = navigator.appName ? navigator.appName : "";
      var fullVersion = '' + parseFloat(navigator.appVersion);
      var majorVersion = parseInt(navigator.appVersion, 10);
      var nameOffset, verOffset, ix;

      // In Opera, the true version is after "Opera" or after "Version"
      if ((verOffset = nAgt.indexOf("Opera")) != -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf("Version")) != -1)
          fullVersion = nAgt.substring(verOffset + 8);
      }
      // In Opera, the true version might also be after "OPR" or after "Version"
      else if ((verOffset = nAgt.indexOf("OPR")) != -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 4);
      }
      // In MSIE, the true version is after "MSIE" in userAgent
      else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
        browserName = "Internet Explorer";
        fullVersion = nAgt.substring(verOffset + 5);
      }
      // In MSIE 11, the true version is rv "Trident" in userAgent
      else if ((verOffset = nAgt.indexOf("Trident/7.0")) != -1) {
        browserName = "Internet Explorer";
        fullVersion = "11.0";
      }
      //start of handling all Edge cases
      else if ((verOffset = nAgt.indexOf("Edg")) != -1) {
        browserName = "Edge";
        fullVersion = nAgt.substring(verOffset + 4);
      }
      else if ((verOffset = nAgt.indexOf("Edge")) != -1) {
        browserName = "Edge";
        fullVersion = nAgt.substring(verOffset + 5);
      }
      else if ((verOffset = nAgt.indexOf("EdgA")) != -1) {
        browserName = "Edge";
        fullVersion = nAgt.substring(verOffset + 5);
      }
      else if ((verOffset = nAgt.indexOf("EdgiOS")) != -1) {
        browserName = "Edge";
        fullVersion = nAgt.substring(verOffset + 7);
      }
      // In Chrome, the true version is after "Chrome" 
      else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset + 7);
      }
      // In Safari, the true version is after "Safari" or after "Version" 
      else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf("Version")) != -1)
          fullVersion = nAgt.substring(verOffset + 8);
      }
      // In Firefox, the true version is after "Firefox" 
      else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset + 8);
      }
      // In most other browsers, "name/version" is at the end of userAgent 
      else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        browserName = nAgt.substring(nameOffset, verOffset);
        fullVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() == browserName.toUpperCase()) {
          browserName = navigator.appName;
        }
      }
      // trim the fullVersion string at semicolon/space if present
      if ((ix = fullVersion.indexOf(";")) != -1)
        fullVersion = fullVersion.substring(0, ix);
      if ((ix = fullVersion.indexOf(" ")) != -1)
        fullVersion = fullVersion.substring(0, ix);

      majorVersion = parseInt('' + fullVersion, 10);
      if (isNaN(majorVersion)) {
        fullVersion = '' + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
      }


      return browserName + ' ' + fullVersion;
    }
  }
};

</script>